import React from 'react';
import Form from "../components/LocationCampaign/Form";

const LocationCampaign: React.FC = () => {

    return (
        <div>
            <Form></Form>
        </div>
    );
};

export default LocationCampaign;